import { Shared as CommonShared } from '@y/shared'

class Shared extends CommonShared {}

const shared = new Shared()

export default shared
